import React from "react";
import { Routes, Route } from "react-router-dom";
import ListRefunds from "../Components/Wallet Refund/listRefunds";
import ViewRefunds from "../Components/Wallet Refund/viewRefunds";

const WalletRefundRoutes = () => {
  return (
    <Routes>
      <Route
        path="/wallet_refund"
        element={<ListRefunds></ListRefunds>}
      ></Route>{" "}
      <Route
        path="/wallet_refund/view/:id"
        element={<ViewRefunds></ViewRefunds>}
      ></Route>
    </Routes>
  );
};

export default WalletRefundRoutes;
